<template>
    <div class="content">
        <div class="content--heading">
            <h1>Settings</h1>
            <div class="heading--actions">
                <a @click="saveConfigs" class="btn btn--icon">
                    <fa :icon="saving ? 'spinner' : 'save'" :class="{'fa-spin': saving}"></fa>
                </a>
            </div>

        </div>

        <div class="configurator--settings panel">
            <editor v-model="configs" @init="editorInit" lang="json" theme="chrome" width="100%" height="500"
                    :options="options"></editor>
        </div>

    </div>
</template>

<script>

    export default {
        name: 'settings',
        components: {
            editor: require('vue2-ace-editor'),
        },
        props: ['settings'],
        data() {
            return {
                configs: '{}',
                saving: false,
                editor: null,
                options: {
                    maxLines: Infinity,
                    wrap: true,
                    printMargin: false
                }
            }
        },
        async created() {
            let me = this;

            await me.$http.get('/data/settings').then(function (r) {
                let response = r.data;

                if (response.settings.project.configs) {
                    me.configs = JSON.stringify(response.settings.project.configs, null, '\t')
                }
            });
        },
        methods: {
            editorInit: function (editor) {
                require('brace/mode/json');
                require('brace/theme/chrome');
                this.editor = editor;
            },
            saveConfigs: function () {
                let me = this,
                    annotations = me.editor.getSession().getAnnotations();

                if ( annotations.length === 0 ) {
                    me.saving = true;

                    me.$http.put('/data/settings', me.configs).then(function (r) {
                        me.saving = false;
                        me.$notify({
                            text: r.data.msg,
                            type: r.data.msgType
                        });
                    });
                } else {
                    for ( let annotation of annotations ) {
                        me.$notify({
                            text: annotation.type + ' in row ' + annotation.row + ': ' + annotation.text,
                            type: annotation.type,
                            duration: -1
                        });
                    }
                }
            }
        }
    }
</script>